/* Measurements are evaluated locally; this guide performs no network requests. */
function zvSizeAdvice(kind,v){
 const empty={text:'Renseignez les champs pour afficher votre repère.',choices:[]};
 const number=x=>Number.isFinite(Number(x))&&String(x).trim()!==''?Number(x):null;
 const w=number(v.width),l=number(v.length);
 if(kind==='posture'){
  const n=number(v.waist);if(n===null)return empty;
  const rows=[['XS',60,70],['S',68,80],['M',78,90],['L',88,100],['XL',98,110],['XXL',108,120],['XXXL',120,130],['XXXXL',130,140]];
  const fits=rows.filter(r=>n>=r[1]&&n<=r[2]).map(r=>r[0]);
  return {text:fits.length?`Pour ${n} cm : ${fits.join(' ou ')} selon le tableau fournisseur.${fits.length>1?' Les deux plages se chevauchent ; comparez le tableau et gardez un ajustement confortable.':''}`:'Cette mesure est hors des plages documentées (60 à 140 cm). Aucune taille ne peut être conseillée avec ce tableau.',choices:fits};
 }
 if(kind==='knee'){
  const n=number(v.thigh);if(n===null)return empty;
  const size=n>=38&&n<46?'S-M':n>=46&&n<=58?'L-XL':null;
  return {text:size?`Pour ${n} cm de tour de cuisse : ${size}.${n===46?' À la limite, ce choix laisse davantage d’aisance.':''}`:'Cette mesure est hors des plages documentées (38 à 58 cm). Le guide ne propose pas de taille adaptée.',choices:size?[size]:[]};
 }
 if(kind==='elbow'){
  const h=number(v.height),kg=number(v.weight);if(h===null||kg===null)return empty;
  const lb=Math.round(kg/0.45359237);let size=null;
  if(h>=152.4&&h<165.1&&lb>=100&&lb<=190)size='S';
  else if(h>=165.1&&h<170.18){if(lb>=130&&lb<=190)size='S';else if(lb>=191&&lb<=210)size='M';}
  else if(h>=170.18&&h<175.26){if(lb>=150&&lb<=175)size='S';else if(lb>=176&&lb<=230)size='M';}
  else if(h>=175.26&&h<180.34){if(lb>=170&&lb<=190)size='S';else if(lb>=191&&lb<=230)size='M';else if(lb>=231&&lb<=250)size='L';}
  else if(h>=180.34&&h<185.42){if(lb>=190&&lb<=210)size='M';else if(lb>=211&&lb<=230)size='L';}
  else if(h>=185.42&&h<=193.04&&lb>=211&&lb<=250)size='L';
  else if(h>193.04&&lb>250)size='XL';
  return {text:size?`Repère fournisseur pour ${h} cm et ${kg} kg : ${size}. Ce repère est approximatif ; comparez les dimensions ci-dessous et vérifiez que le maintien reste confortable.`:'Le tableau fournisseur ne couvre pas cette combinaison de stature et de poids. Comparez les dimensions ci-dessous ; le guide ne déduit pas une taille non documentée.',choices:size?[size]:[]};
 }
 if(kind==='topper'){
  if(w===null||l===null)return empty;
  const variants=[[90,190],[90,200],[150,200],[180,200]];const match=variants.find(r=>(r[0]===w&&r[1]===l)||(r[0]===l&&r[1]===w));
  return {text:match?`Le format correspondant est ${match[0]} × ${match[1]} cm, épaisseur 5 cm.`:'Aucun format proposé ne correspond exactement à ces mesures. Ne choisissez pas un surmatelas plus petit ou plus grand par défaut.',choices:match?[`${match[0]}x${match[1]}cm`]:[]};
 }
 if(kind==='pillowcase'){
  if(w===null||l===null)return empty;
  const a=Math.min(w,l),b=Math.max(w,l);if(a<=0||b<=0)return {text:'Indiquez deux dimensions positives.',choices:[]};
  const length=a<=51?[66,76,91].find(n=>n>=b):null;
  return {text:length?`Le plus petit format proposé pouvant contenir ces dimensions est 51 × ${length} cm. Vérifiez aussi l’épaisseur et la forme de votre oreiller ; ce résultat n’assure pas un ajustement serré.`:'Aucune des trois dimensions proposées ne contient ces mesures. Une taie spécifique sera nécessaire.',choices:length?[`51 × ${length} cm`]:[]};
 }
 if(kind==='laptop'){
  const depth=number(v.depth);if(w===null||depth===null)return empty;
  const size=w>0&&depth>0&&depth<=26?(w<=42?'Standard 42 × 26 cm':w<=48?'Étendu 48 × 26 cm':null):null;
  return {text:size?`Votre base de ${w} × ${depth} cm tient dans les dimensions du plateau ${size}. Vérifiez la stabilité et les ouvertures de ventilation.`:'Ces dimensions dépassent les plateaux documentés ou ne sont pas valides. Le guide ne confirme pas la compatibilité.',choices:size?[size]:[]};
 }
 if(kind==='blanket'){
  if(!v.coverage||!v.feel)return empty;
  if(!['122 × 183 cm','152 × 203 cm'].includes(v.coverage)||!['5,4 kg','6,8 kg'].includes(v.feel))return empty;
  return {text:`Votre préférence : ${v.coverage}, ${v.feel}. Choisissez le format et le poids avec les deux boutons ci-dessous.`,choices:[v.coverage,v.feel]};
 }
 return empty;
}
if(typeof customElements!=='undefined'&&!customElements.get('zv-size-guide')){
 customElements.define('zv-size-guide',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.addEventListener('input',()=>this.update());this.addEventListener('change',()=>this.update());this.update();
  }
  update(){
   const v=Object.fromEntries([...this.querySelectorAll('[data-measure]')].map(e=>[e.dataset.measure,e.value]));const advice=zvSizeAdvice(this.dataset.kind,v);
   this.querySelector('[data-result]').textContent=advice.text;
   this.querySelectorAll('tr[data-size]').forEach(r=>r.classList.toggle('is-compatible',advice.choices.includes(r.dataset.size)));
   const actions=this.querySelector('[data-actions]');actions.replaceChildren();
   advice.choices.forEach(size=>{
    const button=document.createElement('button');button.type='button';button.className='zv-sg-pick';button.textContent='Choisir '+size;
    const scope=this.closest('.product-information')||document;
    const find=()=>[...scope.querySelectorAll('variant-picker input[type="radio"]')].find(e=>e.value===size);
    const input=find();button.disabled=!input||input.disabled;if(button.disabled)button.textContent=size+' — non sélectionnable';
    button.addEventListener('click',()=>{const target=find();if(target&&!target.disabled){target.click();this.querySelector('[data-result]').textContent=advice.text+' Votre choix a été reporté dans le sélecteur du produit.';}});actions.append(button);
   });
  }
 });
}
if(typeof module!=='undefined')module.exports={zvSizeAdvice};
